module.exports = __webpack_public_path__ + "img/RX-Arcos-7.bfbf3914.png";